<mat-toolbar class="sidebar-header">
  <h1 class="page-title">
    <mat-icon color="primary">merge_type</mat-icon>
    {{ 'trackers.merge_trackers' | translate }}
  </h1>

  <span class="tracker-spacer"></span>

  <lib-button (click)="dialogRef.close()" tooltip="{{ 'viewer.close' | translate }}" color="none" textColor="muted" icon="close">
  </lib-button>
</mat-toolbar>

<form class="tracker-form">
  <div class="form-scrollable">
    <div class="form-container">

      <!-- Tracker Name -->
      <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'form.name' | translate }}</mat-label>
        <mat-icon matPrefix>label</mat-icon>
        <input type="text" aria-label="text" matInput [(ngModel)]="mergedTracker.name" name="name" [disabled]="true" />
      </mat-form-field>

      <div class="merge-columns">
        <!-- Left column -->
        <ng-container *ngTemplateOutlet="trackerColumn; context: {
                uuid: leftUUID,
                projects: leftProjects,
                getProjects: getLeftProjects.bind(this),
                loading: loadingProjectList,
                isLeft: true,
                isKept: !mergeLeftToRight
                }">
        </ng-container>

        <!-- Toggle Button -->
        <div class="merge-toggle">
          <div class="merge-toggle-line"></div>
          <lib-button mat-fab color="primary" tooltip="{{ 'form.toggle' | translate }}" (click)="toggleTrackers()"
            [icon]="mergeLeftToRight ? 'arrow_forward' : 'arrow_back'">
          </lib-button>
        </div>

        <!-- Right column -->
        <ng-container *ngTemplateOutlet="trackerColumn; context: {
                uuid: rightUUID,
                projects: rightProjects,
                getProjects: getRightProjects.bind(this),
                loading: loadingProjectList,
                isLeft: false,
                isKept: mergeLeftToRight
                }">
        </ng-container>

      </div>

    </div>
  </div>

  <mat-dialog-actions class="sticky-actions">
    <span class="tracker-spacer"></span>

    <lib-button color="primary" icon="save" (click)="mergeTrackers()" text="{{ 'viewer.save' | translate }}"
      [disabled]="allProjectsFrozen">
    </lib-button>

    <lib-button (click)="dialogRef.close()" color="outline" icon="close" text="{{ 'viewer.close' | translate }}">
    </lib-button>
  </mat-dialog-actions>
</form>

<ng-template #trackerColumn let-uuid="uuid" let-projects="projects" let-getProjects="getProjects" let-loading="loading"
  let-isLeft="isLeft" let-isKept="isKept">
  <div class="column" [ngClass]="{ 'kept-column': isKept, 'deleted-column': !isKept }">
    <div class="column-status" [ngClass]="{ 'status-kept': isKept, 'status-deleted': !isKept }">
      <mat-icon>{{ isKept ? 'check_circle' : 'delete_sweep' }}</mat-icon>
      <span>{{ (isKept ? 'trackers.merge_kept' : 'trackers.merge_deleted') | translate }}</span>
    </div>

    <mat-form-field class="full-width" appearance="outline" *ngIf="uuid" subscriptSizing="dynamic">
      <mat-label>{{ 'trackers.uuid' | translate }}</mat-label>
      <mat-icon matPrefix>fingerprint</mat-icon>
      <input type="text" [ngModel]="uuid" matInput readonly />
    </mat-form-field>

    <mat-card class="tracker-card">
      <h3 class="p-flex project-name">
        <mat-icon>folder</mat-icon>
        <span>{{ 'trackers.project_list' | translate }}</span>
      </h3>

      <ng-container *ngIf="projects.size && (!loading || mergeLeftToRight === isLeft)">
        <mat-list>
          <mat-list-item *ngFor="let project of getProjects()" class="list-item" [ngClass]="{
              'active-item': project.active,
              'frozen-item': project.frozen,
              'pending-item': isLeft ? isRightProject(project) : isLeftProject(project)
            }">
            <div class="project-name">
              <mat-icon matListIcon color="primary">chevron_right</mat-icon>
              <span>{{ project.name }}</span>
            </div>
          </mat-list-item>
        </mat-list>
      </ng-container>

      <div *ngIf="loading && mergeLeftToRight !== isLeft" class="chip-list">
        <lib-chip text="{{ 'status.loading' | translate }}" color="outline" icon="sync">
        </lib-chip>
      </div>
    </mat-card>
  </div>
</ng-template>